import { Button, Modal } from "@clockwise/design-system";
import { bg_neutral } from "@clockwise/design-system/tokens";
import { KeyboardArrowDownRounded, KeyboardArrowUpRounded } from "@material-ui/icons";
import React, { useState } from "react";
import ReactPlayer from "react-player";
import { SectionHeader } from "./components/SectionHeader";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  header: string;
  subheader: string;
  mainContent: React.ReactNode;
  onClickPrimaryButton: () => void;
  videoLink: string;
  primaryButtonText: string;
  secondaryContent?: React.ReactNode;
  onClickSecondaryButton?: () => void;
};

export const EducationModal = ({
  isOpen,
  onClose,
  header,
  subheader,
  mainContent,
  secondaryContent,
  onClickPrimaryButton,
  onClickSecondaryButton,
  videoLink,
  primaryButtonText,
}: Props) => {
  const hasSecondaryContent = !!secondaryContent;
  const [secondaryContentVisible, setSecondaryContentVisible] = useState(false);

  const toggleSecondaryContent = () => {
    setSecondaryContentVisible(!secondaryContentVisible);
  };
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      centered={true}
      radius={11}
      withCloseButton={false}
      size={900}
      styles={{
        content: {
          backgroundColor: bg_neutral,
        },
      }}
      trapFocus={false}
    >
      <div className="cw-flex cw-justify-between cw-font-body cw-h-[500px] cw-w-full cw-overflow-y-hidden">
        <div className="cw-flex cw-basis-[320px]">
          <div className="cw-flex cw-flex-col cw-rounded-lg cw-border cw-border-solid cw-border-muted cw-mr-4 cw-h-full cw-justify-between cw-w-full cw-shadow cw-shadow-subtle">
            <div className="cw-flex cw-flex-col cw-h-full cw-overflow-y-scroll cw-py-5 cw-pl-5 cw-pr-4 cw-bg-default cw-rounded-t-lg">
              <div className="cw-text-16 cw-font-bold cw-text-default cw-leading-5"> {header}</div>
              <div className="cw-text-13 cw-text-muted cw-leading-5 cw-my-1"> {subheader}</div>
              <div className="cw-flex cw-flex-col cw-h-full cw-mt-2 cw-mb-1">
                <SectionHeader>What to know</SectionHeader>
                {mainContent}
              </div>
              {hasSecondaryContent && (
                <div className="cw-flex cw-flex-col cw-h-full cw-my-1">
                  <div
                    className="cw-flex cw-justify-between cw-items-center cw-cursor-pointer cw-w-full"
                    onClick={toggleSecondaryContent}
                  >
                    <SectionHeader>How does it work?</SectionHeader>
                    {secondaryContentVisible ? (
                      <KeyboardArrowUpRounded className="cw-text-muted cw-w-5 cw-h-5" />
                    ) : (
                      <KeyboardArrowDownRounded className="cw-text-muted cw-w-5 cw-h-5" />
                    )}
                  </div>
                  {secondaryContentVisible && <>{secondaryContent}</>}
                </div>
              )}
            </div>

            <div className="cw-flex cw-justify-end cw-gap-x-2 cw-p-3 cw-bg-neutral cw-border-t cw-border-solid cw-border-subtle cw-rounded-b-lg">
              {!!onClickSecondaryButton && (
                <Button
                  size="mini"
                  variant="outlined"
                  sentiment="neutral"
                  onClick={onClickSecondaryButton}
                >
                  Done
                </Button>
              )}
              <Button size="mini" sentiment="positive" onClick={onClickPrimaryButton}>
                {primaryButtonText}
              </Button>
            </div>
          </div>
        </div>
        <div
          className="cw-flex cw-items-center cw-justify-center cw-rounded-lg cw-p-2 cw-grow"
          style={{ background: "linear-gradient(180deg, #4459DD 19.26%, #FFE5FF 130.89%)" }}
          data-chromatic="ignore"
        >
          <ReactPlayer url={videoLink} controls={true} style={{ maxWidth: 520 }} rounded={true} />
        </div>
      </div>
    </Modal>
  );
};
